<template>
    <a
        :href="fileLink"
        target="_blank"
        @mouseenter="isHovering = true"
        @mouseleave="isHovering = false"
        :class="[
            useAccentBg
                ? 'bg-resource-accent'
                : 'bg-resource border border-resource-accent/50',
            ' flex items-center justify-center min-w-full h-full cursor-pointer',
        ]"
    >
        <transition name="fade" mode="out-in">
            <div
                :class="[
                    { 'text-resource-accent': !isHovering && !useAccentBg },
                    {
                        'bg-resource-accent text-resource':
                            isHovering && !useAccentBg,
                    },
                    { 'text-resource': !isHovering && useAccentBg },
                    {
                        'bg-resource text-resource-accent':
                            isHovering && useAccentBg,
                    },
                    { 'scale-105': small && isHovering },
                    { 'scale-110': !small && isHovering },
                    small ? 'p-1.5' : 'p-2.5',
                    'rounded-full translate transition duration-button-hover',
                ]"
            >
                <component
                    :is="isHovering ? 'PhDownloadSimple' : fileTypeIcon"
                    :class="small ? 'size-7' : 'size-8'"
                />
            </div>
        </transition>
    </a>
</template>

<script>
import {
    PhDownloadSimple,
    PhFilePdf,
    PhFileDoc,
    PhFileXls,
    PhFileJpg,
    PhFilePng,
    PhFile,
} from '@phosphor-icons/vue'
import DynamicLink from '@/Components/Utilities/DynamicLink.vue'

export default {
    name: 'FileDownloader',

    components: {
        PhDownloadSimple,
        PhFilePdf,
        PhFileDoc,
        PhFileXls,
        PhFileJpg,
        PhFilePng,
        PhFile,
        DynamicLink,
    },

    props: {
        link: {
            type: [String, null],
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        alt: {
            type: String,
            default: null,
        },
        useAccentBg: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        hadError: false,
        imageLoaded: false,
        isHovering: false,
    }),

    methods: {
        onImageError(error) {
            if (!this.hadError && !this.loading) {
                this.hadError = true
            }
        },

        onImageLoaded() {
            this.imageLoaded = true
        },

        getFileExtension(filename) {
            return filename?.split('.')?.pop()?.toLowerCase() || ''
        },
    },

    computed: {
        fileTypeIcon() {
            const extension = this.getFileExtension(this.link)

            switch (extension) {
                case 'pdf':
                    return PhFilePdf
                case 'doc':
                case 'docx':
                    return PhFileDoc
                case 'xls':
                case 'xlsx':
                    return PhFileXls
                case 'jpg':
                case 'jpeg':
                    return PhFileJpg
                case 'png':
                    return PhFilePng
                default:
                    return PhFile
            }
        },

        /**
         * Returns the file url
         * If the url is missing a leading slash, it will be added
         */
        fileLink() {
            if (this.link?.startsWith('/')) {
                return this.link
            }
            return '/' + this.link
        },
    },
}
</script>
